export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  LOGOUT: "USERS_LOGOUT",
  GET_AUTHENTICATED_USER_DATA: "USERS_GET_AUTHENTICATED_USER_DATA"
};



// WEBPACK FOOTER //
// ./src/_constants/user.constants.js